export default __webpack_public_path__ + "static/media/shamash134.fc864f56.jpg";